import ChartLine from './chart-line.vue';
import ChartLineCustom from './ChartLineCustom.vue';
import ApexChartAreaCustom from './ChartAreaCustom.vue';
import ChartArea from './chart-area.vue';
import ChartNum from './chart-num.vue';
import ChartSlow from './chart-slow.vue';
import ChartHeatmap from './chart-heatmap.vue';
import ChartSankey from './chart-sankey';
import ChartBar from './chart-bar';
import ApexChartLine from './ChartLine';
import ApexChartArea from './ChartArea';
import ChartGauge from './chart-semi-gauge.vue';
import ApexChartBar from './ChartBar';
import ChartMetric from './chart-metric.vue';
export default {
  ChartLine,
  ChartLineCustom,
  ApexChartAreaCustom,
  ChartNum,
  ChartArea,
  ChartSlow,
  ChartHeatmap,
  ChartSankey,
  ChartBar,
  ApexChartLine,
  ApexChartArea,
  ChartGauge,
  ApexChartBar,
  ChartMetric,
};
